import React, { useEffect } from "react";
import Footer from "../components/Footer/Footer";
import "../App.css";

function Home() {
  useEffect(() => {
    // Prevent scrolling on home page
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    return () => {
      // Re-enable scrolling when leaving home page
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  return (
    <div className="App">
      <div className="content">
        <div className="image-container">
          <img
            src={require("../brand.png")}
            className="responsive-logo"
            alt="Brand"
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Home;

